// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * FlightDetailsAndFarePlans.jsx
 * - Desktop/tablet (≥700px): 3 equal-height fare cards
 * - Mobile (<700px): horizontal snap carousel (~84% card width)
 * - Modal shell: pinned header/footer, body-only scroll
 */

.fdfp-fare-modal-shell {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: fit-content;
  min-width: 400px;
  max-width: 1040px;
  height: auto;
  max-height: 90vh;
  outline: none;
  border-radius: 16px;
  box-sizing: border-box;
  margin-inline: auto;
}

@media (max-width: 699.98px) {
  .fdfp-fare-modal-shell {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: auto;
    max-height: 92vh;
    border-radius: 16px 16px 0 0;
    align-self: flex-end;
  }
}

.fdfp-fare-modal-root {
  --fdfp-pad-x: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: auto;
  max-height: 100%;
  min-height: 0;
  flex: 0 1 auto;
  box-sizing: border-box;
}

@media (max-width: 699.98px) {
  .fdfp-fare-modal-root {
    --fdfp-pad-x: 16px;
  }
}

.fdfp-fare-modal-header {
  flex: 0 0 auto;
}

.fdfp-fare-modal-body {
  flex: 0 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  align-content: start;
}

.fdfp-fare-modal-footer {
  flex: 0 0 auto;
  border-top: 1px solid #e6e7ee;
  box-shadow: 0 -4px 12px rgba(32, 32, 42, 0.06);
}

.fdfp-fare-plans-outer {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  padding-left: var(--fdfp-pad-x);
  padding-right: var(--fdfp-pad-x);
  box-sizing: border-box;
}

.fdfp-fare-plans-wrap {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  align-content: start;
  gap: clamp(0.25rem, 1vw, 0.5rem);
  width: max-content;
  max-width: 100%;
  min-width: 0;
  flex: 0 0 auto;
  height: auto;
}

.fdfp-fare-plans__track {
  --fdfp-gap: 0.625rem;
  --fdfp-card-w: 318px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  align-content: start;
  gap: var(--fdfp-gap);
  flex: 0 1 auto;
  width: max-content;
  max-width: 100%;
  min-width: 0;
  height: auto;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  overscroll-behavior-x: contain;
  touch-action: pan-x pan-y;
  scrollbar-width: none;
  padding-bottom: 0.125rem;
  box-sizing: border-box;
}

.fdfp-fare-plans__track::-webkit-scrollbar {
  display: none;
}

.fdfp-fare-plans__slide {
  flex: 0 0 auto;
  align-self: stretch;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  box-sizing: border-box;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.fdfp-fare-plans__slide .fdfp-fare-notice {
  flex: 0 0 auto;
}

.fdfp-fare-plans__slide .fdfp-fare-plans-card {
  flex: 1 0 auto;
  width: 100%;
  height: auto;
  max-height: none;
}

/* Mobile: swipeable row, each card ~84% of the viewport */
@media (max-width: 699.98px) {
  .fdfp-fare-plans-outer {
    flex: 0 1 auto;
    min-height: 0;
    align-content: start;
  }

  .fdfp-fare-plans-wrap {
    flex: 0 0 auto;
    height: auto;
    width: 100%;
    max-width: 100%;
  }

  .fdfp-fare-plans__track {
    flex: 0 1 auto;
    height: auto;
    width: 100%;
    max-width: 100%;
    padding-bottom: max(0.5rem, env(safe-area-inset-bottom, 0px));
  }

  .fdfp-fare-plans__slide {
    width: 84%;
    max-width: 84%;
    flex: 0 0 84%;
  }

  .fdfp-fare-plans__nav {
    display: none;
  }
}

/* Tablet + desktop: three equal-width, equal-height columns */
@media (min-width: 700px) {
  .fdfp-fare-plans-wrap {
    flex: 0 0 auto;
    height: auto;
  }

  .fdfp-fare-plans__track {
    flex: 0 1 auto;
    height: auto;
    scroll-snap-type: none;
  }

  .fdfp-fare-plans__slide {
    min-height: 0;
    width: var(--fdfp-card-w);
    flex: 0 0 var(--fdfp-card-w);
    max-width: var(--fdfp-card-w);
    scroll-snap-align: none;
  }
}

.fdfp-fare-plans__nav {
  flex-shrink: 0;
  align-self: center;
  width: clamp(2.75rem, 5vw, 2.75rem);
  height: clamp(2.75rem, 5vw, 2.75rem);
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  color: #1a1a1a;
  background: #fff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 50%;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.fdfp-fare-plans__nav:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}

.fdfp-fare-plans__nav:disabled {
  opacity: 0.35;
  pointer-events: none;
}

@media (max-width: 699.98px) {
  .fdfp-fare-plans__nav .MuiSvgIcon-root {
    font-size: 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/flight_select/styles/FlightDetailsAndFarePlans.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE;IACE,cAAc;IACd,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,6DAA6D;EAC/D;;EAEA;IACE,UAAU;IACV,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/**\n * FlightDetailsAndFarePlans.jsx\n * - Desktop/tablet (≥700px): 3 equal-height fare cards\n * - Mobile (<700px): horizontal snap carousel (~84% card width)\n * - Modal shell: pinned header/footer, body-only scroll\n */\n\n.fdfp-fare-modal-shell {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: fit-content;\n  min-width: 400px;\n  max-width: 1040px;\n  height: auto;\n  max-height: 90vh;\n  outline: none;\n  border-radius: 16px;\n  box-sizing: border-box;\n  margin-inline: auto;\n}\n\n@media (max-width: 699.98px) {\n  .fdfp-fare-modal-shell {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    height: auto;\n    max-height: 92vh;\n    border-radius: 16px 16px 0 0;\n    align-self: flex-end;\n  }\n}\n\n.fdfp-fare-modal-root {\n  --fdfp-pad-x: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  height: auto;\n  max-height: 100%;\n  min-height: 0;\n  flex: 0 1 auto;\n  box-sizing: border-box;\n}\n\n@media (max-width: 699.98px) {\n  .fdfp-fare-modal-root {\n    --fdfp-pad-x: 16px;\n  }\n}\n\n.fdfp-fare-modal-header {\n  flex: 0 0 auto;\n}\n\n.fdfp-fare-modal-body {\n  flex: 0 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  align-content: start;\n}\n\n.fdfp-fare-modal-footer {\n  flex: 0 0 auto;\n  border-top: 1px solid #e6e7ee;\n  box-shadow: 0 -4px 12px rgba(32, 32, 42, 0.06);\n}\n\n.fdfp-fare-plans-outer {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 0;\n  padding-left: var(--fdfp-pad-x);\n  padding-right: var(--fdfp-pad-x);\n  box-sizing: border-box;\n}\n\n.fdfp-fare-plans-wrap {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  align-content: start;\n  gap: clamp(0.25rem, 1vw, 0.5rem);\n  width: max-content;\n  max-width: 100%;\n  min-width: 0;\n  flex: 0 0 auto;\n  height: auto;\n}\n\n.fdfp-fare-plans__track {\n  --fdfp-gap: 0.625rem;\n  --fdfp-card-w: 318px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  align-content: start;\n  gap: var(--fdfp-gap);\n  flex: 0 1 auto;\n  width: max-content;\n  max-width: 100%;\n  min-width: 0;\n  height: auto;\n  overflow-x: auto;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x mandatory;\n  overscroll-behavior-x: contain;\n  touch-action: pan-x pan-y;\n  scrollbar-width: none;\n  padding-bottom: 0.125rem;\n  box-sizing: border-box;\n}\n\n.fdfp-fare-plans__track::-webkit-scrollbar {\n  display: none;\n}\n\n.fdfp-fare-plans__slide {\n  flex: 0 0 auto;\n  align-self: stretch;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n  box-sizing: border-box;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.fdfp-fare-plans__slide .fdfp-fare-notice {\n  flex: 0 0 auto;\n}\n\n.fdfp-fare-plans__slide .fdfp-fare-plans-card {\n  flex: 1 0 auto;\n  width: 100%;\n  height: auto;\n  max-height: none;\n}\n\n/* Mobile: swipeable row, each card ~84% of the viewport */\n@media (max-width: 699.98px) {\n  .fdfp-fare-plans-outer {\n    flex: 0 1 auto;\n    min-height: 0;\n    align-content: start;\n  }\n\n  .fdfp-fare-plans-wrap {\n    flex: 0 0 auto;\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .fdfp-fare-plans__track {\n    flex: 0 1 auto;\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    padding-bottom: max(0.5rem, env(safe-area-inset-bottom, 0px));\n  }\n\n  .fdfp-fare-plans__slide {\n    width: 84%;\n    max-width: 84%;\n    flex: 0 0 84%;\n  }\n\n  .fdfp-fare-plans__nav {\n    display: none;\n  }\n}\n\n/* Tablet + desktop: three equal-width, equal-height columns */\n@media (min-width: 700px) {\n  .fdfp-fare-plans-wrap {\n    flex: 0 0 auto;\n    height: auto;\n  }\n\n  .fdfp-fare-plans__track {\n    flex: 0 1 auto;\n    height: auto;\n    scroll-snap-type: none;\n  }\n\n  .fdfp-fare-plans__slide {\n    min-height: 0;\n    width: var(--fdfp-card-w);\n    flex: 0 0 var(--fdfp-card-w);\n    max-width: var(--fdfp-card-w);\n    scroll-snap-align: none;\n  }\n}\n\n.fdfp-fare-plans__nav {\n  flex-shrink: 0;\n  align-self: center;\n  width: clamp(2.75rem, 5vw, 2.75rem);\n  height: clamp(2.75rem, 5vw, 2.75rem);\n  min-width: 44px;\n  min-height: 44px;\n  padding: 0;\n  color: #1a1a1a;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n  border-radius: 50%;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.fdfp-fare-plans__nav:hover:not(:disabled) {\n  background: #f5f5f5;\n  border-color: #ccc;\n}\n\n.fdfp-fare-plans__nav:disabled {\n  opacity: 0.35;\n  pointer-events: none;\n}\n\n@media (max-width: 699.98px) {\n  .fdfp-fare-plans__nav .MuiSvgIcon-root {\n    font-size: 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
